import { CalendarIcon, UsersIcon } from "lucide-react";

import { dates } from "@/lib/dates";
import { Job } from "@/types";

export const JobPipelineNumberOfCandidatesAndPublished = ({
  job,
  numberOfCandidates,
}: {
  job: Job;
  numberOfCandidates: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-1">
        <UsersIcon className="h-5 w-5 text-slate-700" />
        <p className="font-medium text-slate-700">
          {numberOfCandidates} candidate{numberOfCandidates !== 1 && "s"}
        </p>
      </div>
      <p className="text-slate-400">•</p>
      <div className="flex items-center gap-1">
        <CalendarIcon className="h-5 w-5 text-slate-700" />
        <p className="font-medium text-slate-700">
          Published {dates.timeAgoForJob(job.createdAt)}
        </p>
      </div>
    </div>
  );
};
